export const resetLocalStorageVariables = _ => {
  localStorage.setItem('calledListPersistFilter', '')
  localStorage.setItem('newTypeFilter', '')
  localStorage.setItem('newFilter', '')
  localStorage.setItem('newSearch', '')
  localStorage.setItem('newOrderFilter', '')
  localStorage.setItem('newOrderSearch', '')
  localStorage.setItem('calledsPage', '')
}